import { useQuery } from "@tanstack/react-query";
import React, { useState } from "react";
import { useRecoilState } from "recoil";
import useQuestionActions from "../../../api/hooks/admin/question";
import { selectedPresetComboListState } from "../../../recoil/admin/preset";
import Table from "../../modules/layout/Table";

const ComboSelect = () => {
  const { fetchComboList } = useQuestionActions();

  const [comboList, setComboList] = useState([]);

  const [selectedComboList, setSelectedComboList] = useRecoilState(
    selectedPresetComboListState
  );

  const { data } = useQuery({
    queryKey: ["fetchComboList"],
    queryFn: () => fetchComboList(),
    onSuccess: () => {
      setComboList(data.data);
    },
  });

  return (
    <>
      <link rel="stylesheet" type="text/css" href="/css/koica.css" />
      <div className="plus-box">
        <p className="plus-title">콤보 선택 (5개 선택 필수)</p>
        <div className="flex" style={{ margin: "15px 0" }}>
          <input
            type="text"
            className="search-input"
            placeholder="분류 입력"
            style={{ width: "200px" }}
          />
          <div>
            <span
              style={{
                fontSize: "14px",
                fontWeight: "500",
                marginRight: "10px",
              }}
            >
              {`${selectedComboList.length}개 선택됨`}
            </span>
            <button className="modal-btn modal-save-btn">선택 초기화</button>
          </div>
        </div>
        <Table
          header={["대분류", "중분류", "시험 유형", "선택"]}
          className="combo-table"
        >
          {/* <tr>
            <td>COMBO 1</td>
            <td>With roommate</td>
            <td>KOICA</td>
            <td>
              <label className="radio-container-plus radio-custom">
                <input className="agree" type="checkbox" />
                <span className="checkmark"></span>
              </label>
            </td>
          </tr> */}
          {comboList.map((combo, key) => (
            <tr key={key}>
              <td>{`COMBO ${combo?.combo}`}</td>
              <td>{combo?.catagory}</td>
              <td>타입</td>
              <td>
                <label className="radio-container-plus radio-custom">
                  <input
                    className="agree"
                    type="checkbox"
                    value={selectedComboList.includes(combo.sn)}
                    onClick={() => {
                      if (selectedComboList.includes(combo.sn)) {
                        const nextValue = [...selectedComboList];
                        nextValue.splice(nextValue.indexOf(combo.sn), 1);
                        setSelectedComboList(nextValue);
                      } else {
                        const nextValue = [...selectedComboList];
                        nextValue.push(combo.sn);
                        setSelectedComboList(nextValue);
                      }
                    }}
                  />
                  <span className="checkmark"></span>
                </label>
              </td>
            </tr>
          ))}
        </Table>
      </div>
    </>
  );
};

export default ComboSelect;
